import {
    GET_CURATED_COLLECTION_SUCCESS, GET_CURATED_COLLECTION_LOADING, GET_CURATED_COLLECTION_ERROR,
    SAVE_CURATED_COLLECTION_SUCCESS, SAVE_CURATED_COLLECTION_LOADING, SAVE_CURATED_COLLECTION_ERROR
} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ""
};

export const GetCuratedCollectionReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CURATED_COLLECTION_LOADING: return { ...state, loading: action.data };
        case GET_CURATED_COLLECTION_SUCCESS: return { ...state, payload: action.data, loading: false };
        case GET_CURATED_COLLECTION_ERROR:   return { ...state, error: action.data, loading: false };
        default: return state;
    }
};

export const SaveCuratedCollectionReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_CURATED_COLLECTION_LOADING: return { ...state, loading: action.data };
        case SAVE_CURATED_COLLECTION_SUCCESS: return { ...state, payload: action.data, loading: false };
        case SAVE_CURATED_COLLECTION_ERROR:   return { ...state, error: action.data, loading: false };
        default: return state;
    }
};
